"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "zola-predosa": {
    "916ea020": [{
      "hkey": "4b1a4b08",
      "slug": "zola-predosa",
      "name": "Zola Predosa",
      "primary": true,
      "skipSearch": false
    }],
    "fontanella": [{
      "hkey": "4b1a4b08",
      "slug": "zola-predosa",
      "name": "Zola Predosa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "46bf2c56": [{
      "hkey": "fbdfe64a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "lavino-di-sopra": [{
      "hkey": "fbdfe64a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "zola-predosa"
    }],
    "d031796e": [{
      "hkey": "fbdfe64a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "rigosa": [{
      "hkey": "fbdfe64a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "zola-predosa"
    }],
    "e4e54696": [{
      "hkey": "330b8db1",
      "slug": "osteria-tombe",
      "name": "Osteria-Tombe",
      "primary": true,
      "skipSearch": false
    }],
    "tombe": [{
      "hkey": "330b8db1",
      "slug": "osteria-tombe",
      "name": "Osteria-Tombe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5328883d": [{
      "hkey": "fbdfe64a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "zola-chiesa": [{
      "hkey": "fbdfe64a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;